export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BOOKING_URL = "https://calendly.com/najahgrowrx_";
